/**
 * These are all types of 'random enchant' items e.g. some cloak of arcane wrath
 */
enum ItemSuffixType {
  Invalid,
  Agility,
  ArcaneResistance,
  ArcaneWrath,
  BeastSlaying,
  Blocking,
  Concentration,
  CriticalStrike,
  Defense,
  Eluding,
  FieryWrath,
  FireResistance,
  FrostResistance,
  FrozenWrath,
  Healing,
  HolyWrath,
  Intellect,
  Marksmanship,
  NatureResistance,
  NaturesWrath,
  Power,
  Proficiency,
  Quality,
  Regeneration,
  Restoration,
  Retaliation,
  ShadowResistance,
  ShadowWrath,
  Sorcery,
  Spirit,
  Stamina,
  Strength,
  Striking,
  TheBear,
  TheBoar,
  TheEagle,
  TheFalcon,
  TheGorilla,
  TheMonkey,
  TheOwl,
  TheTiger,
  TheWhale,
  TheWolf,
  Toughness,
  Twain
}

export default ItemSuffixType
